export default __webpack_public_path__ + "static/media/Mae 9781408327937.a5cd8146.jpg";